import React from "react";
import { useTranslation } from "react-i18next";
import DemoDataNotice from "../shared/DemoDataNotice";

function AIConfidenceGauge({ result, cardStyle, isDemo }) {
const { t } = useTranslation();

return (

<div style={cardStyle}>

<h3>{t("commandCenter.confidenceGauge.title")}</h3>

<div
style={{
display:"flex",
flexDirection:"column",
alignItems:"center",
justifyContent:"center",
gap:"15px",
padding:"20px"
}}
>

<div
style={{
width:"140px",
height:"140px",
borderRadius:"50%",
display:"flex",
alignItems:"center",
justifyContent:"center",
fontSize:"32px",
fontWeight:"bold",
color:"white",
background:
result?.prediction?.confidence >= 80
? "#16a34a"

: result?.prediction?.confidence >= 60
? "#f59e0b"

: "#dc2626"
}}
>

{result?.prediction?.confidence}%

</div>

<div
style={{
fontSize:"18px",
fontWeight:"bold",
color:
result?.prediction?.confidence >= 80
? "#16a34a"

: result?.prediction?.confidence >= 60
? "#f59e0b"

: "#dc2626"
}}
>

{
result?.prediction?.confidence >= 80
? t("commandCenter.status.highConfidence")

: result?.prediction?.confidence >= 60
? t("commandCenter.status.moderateConfidence")

: t("commandCenter.status.lowConfidence")
}

</div>

<div
style={{
textAlign:"center",
color:"#94a3b8"
}}
>

{t("commandCenter.confidenceGauge.description")}

</div>

{isDemo && <DemoDataNotice textKey="common.demoDataNotice.simulatedConfidence" />}

</div>

</div>

);

}

export default AIConfidenceGauge;